import { render } from "./ButtonPagination.vue?vue&type=template&id=0b5cf13a&scoped=true"
import script from "./ButtonPagination.vue?vue&type=script&lang=js"
export * from "./ButtonPagination.vue?vue&type=script&lang=js"

import "./ButtonPagination.vue?vue&type=style&index=0&id=0b5cf13a&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5cf13a"]])

export default __exports__